import styled from "styled-components"
import { boxShadow, displays, textuppercase } from "theme/base/Variables"
import { CardItemStyled } from "theme/common/CardItem.styled"

export const ContentOrderItemstyled = styled.div<{ selected?: boolean }>`
  ${displays.flexBase};
  background: ${({ theme, selected }) => (selected ? theme.palette.grey10 : theme.palette.grey5)};
  border-radius: 13px;

  & .content-order-checked {
    ${displays.flexCenter};
    padding-left: 0.5rem;
  }

  &:hover {
    ${boxShadow.shadow02};
  }
`

export const CardOrderItemStyled = styled(CardItemStyled)`
  position: relative;
  padding: 0.5rem;
  width: 100%;

  & .content-item-order {
    ${displays.flexColumn}
    align-items:flex-start;
    gap: 0.3rem;

    & > .item {
      ${displays.flexBase};
      gap: 0.3rem;
      font-size: 0.714rem;
      color: ${({ theme }) => theme.palette.grey60};
      ${textuppercase};

      &:first-child {
        font-size: 0.8rem;
      }

      & span {
        color: ${({ theme }) => theme.palette.grey90};
        font-weight: bold;
      }
    }
  }
  & .tag {
    ${displays.flexBase};
    gap: 5px;
    position: absolute;
    top: 6px;
    right: 40px;
    font-size: 0.714rem;
    & > svg {
      font-size: 1.5rem;
    }
  }

  & .icon-arrow-rigth {
    position: absolute;
    color: ${({ theme }) => theme.palette.secondary};
    font-size: 1.5rem;
    right: 5px;
  }
  & .icon-storepickup-item {
    color: #ED1E79;
    font-size: 1.3rem;
    position: absolute;
    top: 6px;
    right: 8px;
  }

  & .icon-is_search_approval {
    color: #ED1E79;
    font-size: 1.3rem;
    position: absolute;
    top: 6px;
    right: 35px;
  }

  & .icon-packgeimport-item {
    color: #ED1E79;
    font-size: 1.6rem;
    position: absolute;
    top: 30px;
    right: 6px;
  }

  & .icon-storepickup-meson {
    color: #ED1E79;
    font-size: 1.4rem;
    position: absolute;
    top: 32px;
    right: 7px;
  }

  & .icon-storepickup-express-delivery {
    color: #ED1E79;
    font-size: 1.3rem;
    position: absolute;
    top: 59px;
    right: 8px;
  }

  & .icon-delivery-ultra-express {
    color: #ED1E79;
    font-size: 1.3rem;
    position: absolute;
    top: 79px;
    right: 8px;
  }
`
